<script>
    import { getContext } from 'svelte';
    import Button from 'components/Button';

    const { close } = getContext('simple-modal');

    export let title = 'Loan Processing Begins 2026';
    export let message = 'Standard Credit will begin processing loans in 2026. You can submit your application now to be first in line when we begin disbursements.';
    export let confirmLabel = 'Continue';
    export let cancelLabel = 'Not Now';
    export let onConfirm = () => {};
    export let onCancel = () => {};

    function handleConfirm() {
        onConfirm();
        close();
    }

    function handleCancel(e) {
        e.preventDefault();
        onCancel();
        close();
    }
</script>

<div class="modal">
    <div class="modal-content">
        <h2 class="modal-content__title">{title}</h2>
        <p class="modal-content__desc">{message}</p>
    </div>
    <div class="actions">
        <Button cancel onClick={handleCancel}>{cancelLabel}</Button>
        <Button primary onClick={handleConfirm}>{confirmLabel}</Button>
    </div>
</div>

<style lang="scss">
    @use 'src/sass/base' as *;

    .modal-content {
        margin-bottom: em(60);
        padding: em(45) em(45) 0 em(45);

        &__title {
            margin-bottom: em(25);
            font-size: em(20);
            font-weight: $fw-bold;
            color: $color-primary;
        }

        &__desc {
            font-size: em(16);
            color: $color-gray-text;
            line-height: 1.25;
        }

        :global(p) {
            margin-bottom: em(25);
        }
    }

    .actions {
        padding: em(10) em(25);
        background: $color-gray-light;
        display: flex;
        flex-flow: column wrap;
        justify-content: center;
        align-items: center;
        gap: em(10);
        width: auto;

        @include for-tablet-landscape-up {
            flex-flow: row nowrap;
            justify-content: flex-end;
        }
    }
</style>
